import { BinaryQuestionTemplate, MultipleOptionsTemplate } from '@templates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { scrollTop, parseZodErrors, stringFieldSchema } from '@utils';
import { SELECT_OPTIONS_ERROR } from '@cycle-hangars/constants/errorMessages';

export const KeyTurn = () => {
  const navigate = useNavigate();
  const { doesKeyTurn, updateDoesKeyTurn } = useCycleStore();
  const [result, setResult] = useState(doesKeyTurn);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const title = 'Does the key turn in the lock?';

  const handleChange = (option: string) => {
    setResult(option as 'Yes' | 'No');
    setErrorMessages([]);
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: doesKeyTurn === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: doesKeyTurn === 'No',
    },
  ];

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.CODE_MATCH),
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = stringFieldSchema(
          'doesKeyTurn',
          SELECT_OPTIONS_ERROR.required.message,
        ).parse({
          doesKeyTurn: result,
        });
        if (validatedData.doesKeyTurn) {
          updateDoesKeyTurn(validatedData.doesKeyTurn as 'Yes' | 'No');
        }
        navigate(RoutesList.LOCK_CODE_DETAILS);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  return (
    <BinaryQuestionTemplate
      title={title}
      options={options}
      errorPath={'doesKeyTurn'}
      errorMessages={errorMessages}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
